/**
 * @fileoverview Servicio para validación de Google reCAPTCHA v2
 * @description Maneja la comunicación con el backend para validar tokens de reCAPTCHA
 */

import { buildApiUrl, API_ENDPOINTS, defaultConfig, handleResponse } from '../config/api';

/**
 * Interfaz para la respuesta de validación del captcha
 */
export interface CaptchaValidationResponse {
  success: boolean;
  message?: string;
}

/**
 * Servicio para validar tokens de reCAPTCHA con el backend
 */
export const captchaService = {
  /**
   * Valida un token de reCAPTCHA con el backend
   * @param token - Token de reCAPTCHA obtenido del widget
   * @returns Promise con la respuesta de validación
   * @throws Error si la validación falla
   */
  async validateCaptcha(token: string): Promise<CaptchaValidationResponse> {
    try {
      
      const response = await fetch(buildApiUrl(API_ENDPOINTS.VALIDATE_CAPTCHA), {
        method: 'POST',
        ...defaultConfig,
        body: JSON.stringify({
          'g-recaptcha-response': token
        })
      });

      const data = await handleResponse(response);
      
      
      return {
        success: data.success === true,
        message: data.message
      };
    } catch (error: any) {
      throw new Error(error.message || 'Error al validar el reCAPTCHA');
    }
  }
};



